import React, { useRef, useEffect } from "react";

const Video: React.FC = () => {
  const videoEl = useRef(null);

  const attemptPlay = () => {
    // if (videoEl && videoEl.current) {
    //   videoEl.current.play().catch((error) => {
    //     console.error("Error attempting to play", error);
    //   });
    // }
  };

  useEffect(() => {
    attemptPlay();
  }, []);

  return (
    <div>
      <div>
        <video
          style={{ width: "100%", margin: "0 auto" }}
          playsInline
          loop
          muted
          autoPlay
          src="https://elliecare-public-images.s3.sa-east-1.amazonaws.com/web/video-header.mp4"
          ref={videoEl}
        />
      </div>
    </div>
  );
};

export default Video;
